<pop-settings-box labelKey="DATA_MANAGEMENT.DEFAULT_DEPARTMENT">

  <pop-department-picker [(selectedDepartment)]="selectedDepartment"
                         (selectedDepartmentChange)="selectDepartment($event)"
                         styleClass="rem-fix"></pop-department-picker>
</pop-settings-box>
